(function($) {
    $(function () {
        const ONE_YEAR = 365 * 24 * 60 * 60 * 1000;

        $('.list_change').on('click', function (e) {
            e.preventDefault();

            const expiresDate = new Date(Date.now() + ONE_YEAR);
            const expires = `; expires=${expiresDate.toUTCString()}`;

            const $products = $('.products');
            const $listChangeIcon = $('.list_change i');
            const $searchButton = $('.button-under-separator__search');
            const $searchContainer = $('.container-under-separator__search');

            const isTiles = $products.toggleClass('tiles').hasClass('tiles');
            const newView = isTiles ? 'tiles' : 'list';

            $listChangeIcon
                .toggleClass('b-cell-icon', !isTiles)
                .toggleClass('fa-list', isTiles);

            $searchButton.toggle(!isTiles);
            $searchContainer.toggleClass('static', isTiles);

            document.cookie = `product-view=${newView}${expires}; path=/`;

            $('html, body').animate({ scrollTop: 0 }, 1000);
        });
    });

    function handleProductView() {
        var name = 'product-view';
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');

        var foundCookie = false;
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);

            if (c.indexOf(nameEQ) === 0) {
                foundCookie = true;
                var val = c.substring(nameEQ.length, c.length);

                if (val === 'tiles') {
                    $('.products').addClass('tiles');
                    $('.list_change i').removeClass('b-cell-icon').addClass('fa-list');
                    $('.button-under-separator__search').hide();
                    $('.container-under-separator__search').addClass('static');
                }
                break;
            }
        }

        if (!foundCookie) {
            var date = new Date();
            date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toUTCString();

            document.cookie = "product-view=list" + expires + "; path=/";
        }
    }

    handleProductView();

    function hideListChange() {
        if($(window).width() < 768) {
            $('.list_change').hide();
            $('.products').removeClass('tiles');
        } else {
            $('.list_change').show();
        }
    }

    hideListChange();
    $(window).on('resize', function () {
        hideListChange();
    });
})(jQuery);